const NotFound = () => {
  return (
    <div className="fallbackContainer">
      <div className="fallbackDiv">
        <h1>Store currently unavailable</h1>
        <p>
          We couldn’t load this store location right now. It might be
          temporarily down or misconfigured.
        </p>
      </div>
    </div>
  );
};
export default NotFound;
